export default __webpack_public_path__ + "static/media/profile-background-default.1c07b845.png";